export class GeneralMessages {
  public menu = 'general.menu';
  public ok = 'general.ok';
  public page = 'general.page';
  public requisA = 'general.requisA';
  public requisB = 'general.requisB';
}
